import { Layout } from "@jambushrushti/components/layout/Layout";
import { Card, CardContent } from "@jambushrushti/components/ui/card";
import { Button } from "@jambushrushti/components/ui/button";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  Newspaper,
  Calendar,
  MapPin,
  ExternalLink,
  Bell,
} from "lucide-react";

const newsItems = [
  {
    id: 1,
    title: "श्रीजम्बूविजयजी म.सा. की वार्षिक पुण्यतिथि समारोह",
    titleEn: "Annual Remembrance Ceremony of Shri Jambuvijayji Maharaj Saheb",
    date: "November 20, 2024",
    location: "Shantigram, Gujarat",
    description:
      "The annual memorial ceremony honoring Gurudev was observed with spiritual discourses, prayers, and community gatherings.",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/WhatsApp-Image-2020-10-21-at-11.31.35-PM-261x152.jpeg",
    type: "Event",
  },
  {
    id: 2,
    title: "ભવ્ય ઉપધાન તપ આયોજન",
    titleEn: "Grand Updhan Tap Ceremony Organized",
    date: "December 18, 2024 - February 5, 2025",
    location: "Multiple Locations",
    description:
      "A significant spiritual austerity program following traditional Jain practices, organized by the Parivar.",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2021/05/MicrosoftTeams-image-22-270x152.jpg",
    type: "Spiritual Program",
  },
  {
    id: 3,
    title: "New Manuscript Collection Added to Digital Archive",
    titleEn: "New Manuscript Collection Added to Digital Archive",
    date: "October 15, 2024",
    location: "Muni Jambuvijayaji Research Center",
    description:
      "50 new rare manuscripts have been digitized and added to our searchable online collection.",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/99-min.jpg",
    type: "Update",
  },
  {
    id: 4,
    title: "Janm Shatabdi Mahotsav Documentary Released",
    titleEn: "Centenary Celebration Documentary Released",
    date: "September 28, 2024",
    location: "Online",
    description:
      "A comprehensive documentary covering Gurudev's centenary celebrations is now available for viewing.",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/107-min.jpg",
    type: "Media",
  },
  {
    id: 5,
    title: "Research Collaboration with Universities Announced",
    titleEn: "Research Collaboration with Universities Announced",
    date: "August 10, 2024",
    location: "Academic",
    description:
      "Partnerships established with leading universities for Jain manuscript research and preservation.",
    image:
      "https://siddhijambuparivar.com/wp-content/uploads/2022/11/111-min.jpg",
    type: "Announcement",
  },
];

const News = () => {
  return (
    <Layout>
      {/* Hero */}
      <section
        className="py-16 lg:py-20"
        style={{ backgroundColor: "#FAF7F2" }}
      >
        <div className="container mx-auto px-4">
          <div className="animate-fade-up mx-auto max-w-3xl text-center">
            <p
              className="mb-3 text-sm font-semibold uppercase tracking-wider"
              style={{ color: "#D2811D", fontFamily: "Inter, sans-serif" }}
            >
              Our News
            </p>
            <h1
              className="mb-6 text-4xl font-bold sm:text-5xl"
              style={{
                fontFamily: "Playfair Display, serif",
                color: "#2D2A26",
              }}
            >
              News <span style={{ fontStyle: "italic" }}>&</span> Announcements
            </h1>
            <p className="text-lg" style={{ color: "#6B6764" }}>
              Stay informed about events, updates, and announcements from
              Jambushrusti and the Siddhi Jambu Parivar community.
            </p>
          </div>
        </div>
      </section>

      {/* Featured News */}
      <section className="bg-background py-12 lg:py-16">
        <div className="container mx-auto px-4">
          {newsItems.length > 0 && (
            <Card
              variant="feature"
              className="animate-fade-up mb-12 overflow-hidden"
            >
              <div className="grid gap-0 md:grid-cols-2">
                <div className="aspect-[4/3] overflow-hidden md:aspect-auto">
                  <img
                    src={newsItems[0].image}
                    alt={newsItems[0].titleEn}
                    className="h-full w-full object-cover"
                  />
                </div>
                <CardContent className="flex flex-col justify-center p-8">
                  <div className="mb-4 flex items-center gap-3">
                    <span className="rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
                      {newsItems[0].type}
                    </span>
                    <span className="text-sm text-muted-foreground">
                      Featured
                    </span>
                  </div>
                  <h2 className="font-display mb-2 text-2xl font-bold text-foreground">
                    {newsItems[0].title}
                  </h2>
                  <p className="mb-2 text-muted-foreground">
                    {newsItems[0].titleEn}
                  </p>
                  <p className="mb-4 text-muted-foreground">
                    {newsItems[0].description}
                  </p>
                  <div className="mb-6 flex flex-wrap gap-4 text-sm text-muted-foreground">
                    <div className="flex items-center gap-2">
                      <Calendar className="h-4 w-4 text-primary" />
                      <span>{newsItems[0].date}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <MapPin className="h-4 w-4 text-primary" />
                      <span>{newsItems[0].location}</span>
                    </div>
                  </div>
                  <Button variant="hero" className="w-fit">
                    Read More
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </CardContent>
              </div>
            </Card>
          )}

          {/* News Grid */}
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {newsItems.slice(1).map((news, index) => (
              <Card
                key={news.id}
                variant="interactive"
                className="animate-fade-up group overflow-hidden"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={news.image}
                    alt={news.titleEn}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <CardContent className="p-5">
                  <div className="mb-3 flex items-center gap-2">
                    <span className="rounded-full bg-secondary px-2 py-1 text-xs text-muted-foreground">
                      {news.type}
                    </span>
                  </div>
                  <h3 className="font-display mb-1 line-clamp-2 font-semibold text-foreground transition-colors group-hover:text-primary">
                    {news.titleEn}
                  </h3>
                  <p className="mb-3 line-clamp-2 text-sm text-muted-foreground">
                    {news.description}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <Calendar className="h-3 w-3" />
                      <span>{news.date}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <MapPin className="h-3 w-3" />
                      <span>{news.location}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* External Events Link */}
      <section className="bg-gradient-spiritual py-12">
        <div className="container mx-auto px-4 text-center">
          <h2 className="font-display mb-4 text-2xl font-bold text-foreground">
            View All Events
          </h2>
          <p className="mx-auto mb-6 max-w-xl text-muted-foreground">
            Visit the official Siddhi Jambu Parivar website for complete event
            listings
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button variant="hero" asChild>
              <a
                href="https://siddhijambuparivar.com/events-list/"
                target="_blank"
                rel="noopener noreferrer"
              >
                View All Events
                <ExternalLink className="ml-2 h-4 w-4" />
              </a>
            </Button>
            <Button variant="outline" asChild>
              <Link to="/community/events">Community Events</Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Subscribe */}
      <section className="bg-background py-16">
        <div className="container mx-auto px-4">
          <Card variant="feature" className="mx-auto max-w-2xl">
            <CardContent className="p-8 text-center">
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
                <Bell className="h-7 w-7 text-primary" />
              </div>
              <h3 className="font-display mb-2 text-xl font-bold text-foreground">
                Get Notified
              </h3>
              <p className="mb-6 text-muted-foreground">
                Subscribe to receive updates about events, new articles, and
                community announcements
              </p>
              <Button variant="hero">
                Subscribe to Updates
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>
  );
};

export default News;
